/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useDispatch } from 'react-redux';
import CloudIcon from '../../assets/UploadIcon';
import Theme from '../ui/Theme';
import { ErrorToast, flattenFiles, notifySuccess } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  btnStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: Theme.palette.primary.main,
  },
}));

export default function UploadButton(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        name={props.name}
        accept="image/png, image/jpeg, image/jpg"
        className={classes.input}
        id={props.id ?? 'upload-image'}
        multiple
        onChange={props.handleImageUpload}
        type="file"
      />
      <label htmlFor={props.id ?? 'upload-image'}>
        <Button
          startIcon={<CloudIcon />}
          variant="contained"
          style={
            props.outline
              ? { height: '30px', border: '1px solid #E4E7EC', background: 'white' }
              : { height: '24px', background: 'white' }
          }
          disableElevation
          component="span"
        >
          <div className={classes.btnStyle}>Upload</div>
        </Button>
      </label>
    </div>
  );
}

export function UploadFolderButton({ name, urlValue, setUrlValue }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleUpload = async (e) => {
    const filesData = e.target?.files || [];
    const suffix = urlValue && !urlValue.startsWith('http') ? urlValue : Date.now();

    if (!filesData || !filesData.length) {
      ErrorToast('Upload folder with file content');
      return;
    }

    const actualFolderName = `${filesData[0].webkitRelativePath.split('/')[0]}`;

    const folderName = `${actualFolderName}_${suffix}`;

    const formData = new FormData();
    formData.append('folderName', folderName);

    flattenFiles(filesData).forEach(({ file, uploadDir }) => {
      const newFilePath = uploadDir.replace(actualFolderName, folderName);
      formData.append(newFilePath, file);
    });

    dispatch(showProgress(true));
    try {
      const result = await service.post(apiEndpoints.INTERACTION_UPLOAD, formData, {
        'Content-Type': 'application/x-www-form-urlencoded',
      });
      notifySuccess('Uploaded all interaction files to S3 Successfully.');
      setUrlValue(result.interactionUrl);
    } catch (err) {
      ErrorToast(err);
    }
    dispatch(showProgress(false));
  };

  return (
    <div className={classes.root}>
      <input
        name={name}
        className={classes.input}
        id="btn_upload_folder"
        multiple
        onChange={handleUpload}
        type="file"
        webkitdirectory=""
        directory=""
      />
      <label htmlFor="btn_upload_folder">
        <Button
          startIcon={<CloudIcon />}
          variant="contained"
          style={{ height: '24px', background: 'white' }}
          disableElevation
          component="span"
        >
          <div className={classes.btnStyle}>Upload Folder</div>
        </Button>
      </label>
    </div>
  );
}
